import React from 'react'
//import "./MarqueeText.css";

interface MarqueeTextProps {
    text: string
    speed?: number // duración total del ciclo en segundos
}

const MarqueeText: React.FC<MarqueeTextProps> = ({ text, speed = 10 }) => {
    return (
        <div className="relative w-full h-10 overflow-hidden">
            <div
                className="absolute w-full whitespace-nowrap animate-marquee"
                style={{ animationDuration: `${speed}s` }}
            >
                <span className="mx-4">{text}</span>
            </div>
        </div>
    )
}

export default MarqueeText
